import { render, staticRenderFns } from "./NavigateableTab.vue?vue&type=template&id=60305772&"
import script from "./NavigateableTab.vue?vue&type=script&lang=js&"
export * from "./NavigateableTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60305772')) {
      api.createRecord('60305772', component.options)
    } else {
      api.reload('60305772', component.options)
    }
    module.hot.accept("./NavigateableTab.vue?vue&type=template&id=60305772&", function () {
      api.rerender('60305772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/NavigateableTab.vue"
export default component.exports